import { queryOptions } from '@tanstack/react-query';

import type { SymbolKey } from '@/entities/symbol';

import { exportPreviewApi } from './exportPreview.api';

export type ExportPreviewListFilters = {
  symbolsKey: string[];
  from: string | null;
  to: string | null;
  includeMetadata: boolean;
  exportType: string;
  isCSV: boolean;
  userTimezone: string;
};

export function getSymbolsQueryKey(symbols: SymbolKey[]): string[] {
  return symbols
    .map(symbol =>
      [symbol.Code, symbol.Period, symbol.PeriodType, symbol.TimeRef]
        .map(value => value ?? '')
        .join('|')
    )
    .sort((a, b) => a.localeCompare(b));
}

export const exportPreviewOptions = {
  all: () => ['dataHub', 'exportPreview'] as const,
  lists: () => [...exportPreviewOptions.all(), 'list'] as const,
  details: () => [...exportPreviewOptions.all(), 'detail'] as const,
  detail: (id: string) => [...exportPreviewOptions.details(), id] as const,

  list: (filters: ExportPreviewListFilters, symbols: SymbolKey[]) =>
    queryOptions({
      queryKey: [...exportPreviewOptions.lists(), filters, filters.symbolsKey, symbols] as const,
      queryFn: () =>
        exportPreviewApi.fetchPreviewList(
          {
            from: filters.from ?? '',
            to: filters.to,
            includeMetadata: filters.includeMetadata,
            isCSV: filters.isCSV,
            userTimezone: filters.userTimezone
          },
          symbols,
          filters.isCSV ? { Accept: 'text/csv' } : undefined
        ),
      enabled: symbols.length > 0,
      staleTime: 1000 * 60 // 1 minute
    })
};
